// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disable-step[data-v-5e61b36c] {\n  background-color: #50585c;\n  border-color: #50585c;\n}", ""]);
// Exports
module.exports = exports;
